function isString(object) {
  return (
    object === '' ||
    (Boolean(object) &&
      (typeof object === 'string' || object instanceof String))
  );
}

export default isString;
